import { render, staticRenderFns } from "./monthlyPayrollNew.vue?vue&type=template&id=2762c9ca&scoped=true"
import script from "./monthlyPayrollNew.vue?vue&type=script&lang=js"
export * from "./monthlyPayrollNew.vue?vue&type=script&lang=js"
import style0 from "./monthlyPayrollNew.vue?vue&type=style&index=0&id=2762c9ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2762c9ca",
  null
  
)

export default component.exports